import { render, staticRenderFns } from "./accountsSummaryWidget.vue?vue&type=template&id=b73758d4&"
import script from "./accountsSummaryWidget.vue?vue&type=script&lang=js&"
export * from "./accountsSummaryWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports